import React from "react";
import { observable } from "mobx";
import { MDBBtn } from "mdbreact";
import { AppStore } from "../../stores/AppStore";
import { MonitoraTopicStore } from "../../stores/monitora/MonitoraTopicStore";
import { AppIcon } from "../utils/AppIcon";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { toast } from "react-toastify";
import moment from "moment";
import { Button, Classes, Dialog, FormGroup, H5, InputGroup, Popover } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { IconButton } from "@mui/material";
import "../../assets/css/monitora.css";

const n = (v: unknown): number => {
  const x = parseInt(String(v), 10);
  return Number.isNaN(x) ? 0 : x;
};

const fmt = new Intl.NumberFormat("pt-BR");

const WARN_LAG = 1;
const CRIT_LAG = 1000;
const WARN_STALE_SECONDS = 30;
const CRIT_STALE_SECONDS = 90;

const MASK_HOSTS = false;

type Tone = "ok" | "warn" | "crit";

const lagTone = (lag: number): Tone =>
  lag >= CRIT_LAG ? "crit" : lag >= WARN_LAG ? "warn" : "ok";

const maskHost = (host: string): string =>
  MASK_HOSTS ? host.replace(/(\d+)\.(\d+)$/, "•.•") : host;

@observer
export class MonitoraTopicPage extends React.Component<{}, {}> {

  obs = observable({
    selected: null as number | null,
    now: Date.now(),
    monitoring: false,
    paused: false,
    topicIndex: 0,
    open_topics: false,
    open_monitorar: false,
    monitorar_filter: "",
    ip_filter: "",
    tone_filter: null as Tone | null,
    show_hosts: false,
    selected_topics: []
  });

  private tick?: ReturnType<typeof setInterval>;
  private poll?: ReturnType<typeof setInterval>;

  componentDidMount() {
    AppStore.setTitle("Monitoramento Tópicos");

    this.tick = setInterval(() => {

      this.obs.now = Date.now();

    }, 1000);

  }

  componentWillUnmount() {
    if (this.tick) clearInterval(this.tick);
    if (this.poll) clearInterval(this.poll);
  }

  startPolling = () => {

    if (this.poll) clearInterval(this.poll);

    this.poll = setInterval(async () => {

      const topicIndex = (this.obs.topicIndex + 1) % this.obs.selected_topics.length;

      if (this.obs.selected_topics[topicIndex] !== this.obs.selected_topics[this.obs.topicIndex]) {
        this.obs.ip_filter = "";
        this.obs.tone_filter = null;
      }

      this.obs.selected = null;

      await MonitoraTopicStore.handleMonitorar(this.obs.selected_topics[topicIndex]);

      this.obs.topicIndex = topicIndex

      AppStore.resetTimer()

    }, 10000);

  };

  async handleOpenMonitorar() {

    await MonitoraTopicStore.handleTopics()

    this.obs.selected_topics = []

    this.obs.open_monitorar = true

  }

  handleMonitorar = async () => {

    if (!this.obs.selected_topics.length) {
      toast.warn("Selecione um ou mais tópicos para monitorar.", {})
      return
    }

    this.obs.open_monitorar = false

    this.obs.monitoring = true;
    this.obs.paused = false;
    this.obs.topicIndex = 0;
    this.obs.selected = null;
    this.obs.ip_filter = "";
    this.obs.tone_filter = null;

    await MonitoraTopicStore.handleMonitorar(this.obs.selected_topics[this.obs.topicIndex]);

    this.startPolling();

  };

  handlePausar = () => {
    if (this.poll) clearInterval(this.poll);
    this.poll = undefined;
    this.obs.paused = true;
  };

  handleContinuar = async () => {
    this.obs.paused = false;

    await MonitoraTopicStore.handleMonitorar(this.obs.selected_topics[this.obs.topicIndex]);

    this.startPolling();
  };

  handleParar = () => {
    if (this.poll) clearInterval(this.poll);
    this.poll = undefined;
    this.obs.monitoring = false;
    this.obs.paused = false;
  };

  onAfterSaveCell = async (row, cellName, cellValue) => {

    if (!row.topic) {
      toast.warn("Campo Tópico não pode ficar em branco.", {})
      return
    }

    if (row._id) {

      const data = {
        id: row._id,
        topic: row.topic
      }

      await MonitoraTopicStore.handleUpdateTopic(data)

    } else {

      const data = {
        topic: row.topic
      }

      await MonitoraTopicStore.handleCreateTopic(data)

    }

    await MonitoraTopicStore.handleTopics()

  }

  formaterLocator = (cell, row) => {

    if (!cell) return ""

    return (
      <span style={{ fontSize: 10 }}>{cell}</span>
    )

  };

  formaterDate = (cell, row) => {

    if (!cell) return "N/A"

    return (
      <span style={{ fontSize: 10 }}>{moment(cell).format("DD/MM/YYYY")}</span>
    )

  };

  formaterDetalhes = (cell, row) => {

    if (!row._id) {
      return (
        <MDBBtn color="default" rounded size="sm" onClick={() => {
          let index = MonitoraTopicStore.obs.topics.findIndex(obj => obj._id === row._id);

          if (index !== -1) {
            MonitoraTopicStore.obs.topics.splice(index, 1);
          }
        }}>
          <img src="/images/bin.png" width="25px" />
        </MDBBtn>
      )
    }

    return (
      <>
        <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
          <MDBBtn color="default" rounded size="sm">
            <img src="/images/bin.png" width="25px" />
          </MDBBtn>
          <div>
            <H5>Confirmar exclusão?</H5>
            <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,
              }}
            >
              <Button
                className={Classes.POPOVER_DISMISS}
                style={{ marginRight: 10 }}
              >
                Cancelar
              </Button>
              <Button
                intent="danger"
                className={Classes.POPOVER_DISMISS}
                onClick={() => this.handleDeleteLocator(row._id)}
              >
                Excluir
              </Button>
            </div>
          </div>
        </Popover>
      </>
    )
  }

  async handleOpenTopicos() {

    await MonitoraTopicStore.handleTopics()

    this.obs.open_topics = true

  }

  async handleDeleteLocator(id) {

    const res = await MonitoraTopicStore.handleDeleteTopic(id)

    if (res) await MonitoraTopicStore.handleTopics()

  }

  createCustomSearchField = (props) => {

    return (
      <SearchField
        className="input-filter input-filter-sefa-agendamento"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Tópico)"
      />
    );

  };

  moveTopic = (index: number, dir: -1 | 1) => {

    const target = index + dir;

    const arr = this.obs.selected_topics;

    if (target < 0 || target >= arr.length) return;

    const [item] = arr.splice(index, 1);

    arr.splice(target, 0, item);

  };

  addTopic = (topic: string) => {

    if (!this.obs.selected_topics.includes(topic)) {

      this.obs.selected_topics.push(topic);

    }

  };

  removeTopic = (topic: string) => {

    const index = this.obs.selected_topics.indexOf(topic);

    if (index !== -1) this.obs.selected_topics.splice(index, 1);

  };

  addAllTopics = (topics: string[]) => {

    topics.forEach((topic) => {

      if (!this.obs.selected_topics.includes(topic)) {

        this.obs.selected_topics.push(topic);

      }

    });

  };

  removeAllTopics = () => {

    this.obs.selected_topics = [];

  };

  render() {

    const options = {
      searchField: this.createCustomSearchField,
    };

    const textEdit = {
      type: "input",
    }

    const cellEditProp = {
      mode: 'click',
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell
    };

    const monitorarFilter = this.obs.monitorar_filter.trim().toLowerCase();

    const availableTopics = (MonitoraTopicStore.obs.topics || [])
      .map((t) => t.topic)
      .filter(Boolean)
      .filter((topic) => !this.obs.selected_topics.includes(topic))
      .filter((topic) => !monitorarFilter || topic.toLowerCase().includes(monitorarFilter));

    const topics = (MonitoraTopicStore.obs.consumers || []);

    const first: any = topics.length ? topics[0] : null;

    const totalLag = topics.reduce((acc, t) => acc + n(t.lag), 0);
    const totalProcessado = topics.reduce((acc, t) => acc + n(t.current_offset), 0);
    const maxLag = topics.reduce((m, t) => Math.max(m, n(t.lag)), 0);

    const hostMap = new Map<string, number>();

    topics.forEach((t) => hostMap.set(t.host, (hostMap.get(t.host) ?? 0) + 1));

    const hosts = Array.from(hostMap.entries())
      .map(([host, count]) => ({ host, count }))
      .sort((a, b) => b.count - a.count);

    const lastUpdated = MonitoraTopicStore.obs.lastUpdated;

    const secondsAgo =
      lastUpdated != null
        ? Math.max(0, Math.floor((this.obs.now - new Date(lastUpdated).getTime()) / 1000))
        : null;

    const freshness: "fresh" | "warn" | "stale" | null =
      secondsAgo == null
        ? null
        : secondsAgo >= CRIT_STALE_SECONDS
          ? "stale"
          : secondsAgo >= WARN_STALE_SECONDS
            ? "warn"
            : "fresh";

    const isStale = freshness === "stale";

    const updatedTone: Tone =
      secondsAgo == null
        ? "ok"
        : secondsAgo > 30
          ? "crit"
          : secondsAgo > 15
            ? "warn"
            : "ok";

    const health: Tone = maxLag >= CRIT_LAG ? "crit" : maxLag >= WARN_LAG ? "warn" : "ok";

    const statusLabel = isStale
      ? "Crítico"
      : health === "crit"
        ? "Crítico"
        : health === "warn"
          ? "Atenção"
          : "Em dia";

    const statusTone: Tone = isStale ? "crit" : health;

    const ipFilter = this.obs.ip_filter.replace(/\D/g, "")

    const toneFilter = this.obs.tone_filter;

    const ordered = [...topics]
      .sort((a, b) => n(a.partition) - n(b.partition))
      .filter((t) => !ipFilter || (t.host ?? "").replace(/\D/g, "").includes(ipFilter))
      .filter((t) => !toneFilter || lagTone(n(t.lag)) === toneFilter);

    const selected = ordered.find((t) => n(t.partition) === this.obs.selected);

    const updatedStatus =
      secondsAgo == null
        ? "AO VIVO"
        : secondsAgo > 30
          ? "SEM DADOS"
          : secondsAgo > 15
            ? "ATRASADO"
            : "AO VIVO";

    return (
      <>
        {!this.obs.monitoring ? (
          <MDBBtn className="btnDefault" onClick={() => this.handleOpenMonitorar()}>
            Iniciar Monitoramento
          </MDBBtn>
        ) : (<>
          {this.obs.paused ? (
            <MDBBtn className="btnDefault" onClick={() => this.handleContinuar()}>
              Continuar Monitoramento
            </MDBBtn>
          ) : (
            <MDBBtn className="btnDefault" onClick={() => this.handlePausar()}>
              Pausar Monitoramento
            </MDBBtn>
          )}
          <MDBBtn className="btnDefault btnDefault-danger" onClick={() => this.handleParar()}>
            Parar Monitoramento
          </MDBBtn>
        </>)}

        {!this.obs.monitoring && (
          <MDBBtn className="btnDefault" style={{ float: "right" }} onClick={() => this.handleOpenTopicos()}>
            Tópicos
          </MDBBtn>
        )}

        <br />
        <br />

        {this.obs.monitoring && (
          <div className="kqm-progress">
            <div className="kqm-progress-meta">
              <span>{this.obs.paused ? "Monitoramento pausado" : "Percorrendo tópicos"}</span>
              <span>
                {this.obs.topicIndex + 1} / {this.obs.selected_topics.length}
              </span>
            </div>
            <div className="kqm-progress-track">
              <div
                className={`kqm-progress-fill${this.obs.paused ? " is-paused" : ""}`}
                style={{
                  width: `${((this.obs.topicIndex + 1) / this.obs.selected_topics.length) * 100}%`,
                }}
              />
            </div>
          </div>
        )}

        <div className={`kqm${isStale ? " is-stale" : ""}`}>
          {!MonitoraTopicStore.obs.consumers ?
            <div className="kqm-detail">
              <div className="kqm-detail-empty">
                O grupo de consumer <b>{this.obs.selected_topics[this.obs.topicIndex]}group</b> não possui tópicos ativos.
              </div>
            </div>
            : <>
              {topics.length === 0 ? (
                <div className="kqm-detail">
                  <div className="kqm-detail-empty">
                    Clique em “Monitorar” para carregar as partições.
                  </div>
                </div>
              ) : (<>
                <div className="kqm-bar">
                  <div className="kqm-bar-id">
                    <div className="kqm-title">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppIcon name="topic" size={20} />&nbsp;{first.group}</div>
                    </div>
                    <div className="kqm-sub">
                      tópico: {first.topic ?? "—"} · {topics.length} partições
                    </div>
                  </div>

                  <div className="kqm-bar-status">
                    <span className={`kqm-status kqm-tone-${statusTone}`}>
                      <span className="kqm-dot" />
                      {statusLabel}
                    </span>
                    {secondsAgo != null && (
                      <span className={`kqm-updated kqm-updated-${updatedTone}`}>
                        <span className="kqm-dot" />
                        {updatedStatus} -
                        atualizado há {secondsAgo}s
                      </span>
                    )}
                  </div>

                </div>

                {isStale && (
                  <div className="kqm-staleband" role="alert">
                    Coleta interrompida — última leitura há {secondsAgo}s.
                  </div>
                )}

                <div className="kqm-kpis">
                  <div className="kqm-kpi">
                    <div className="kqm-kpi-label">Total pendentes</div>
                    <div className={`kqm-kpi-value kqm-fg-${health}`}>
                      {fmt.format(totalLag)}
                    </div>
                  </div>
                  <div className="kqm-kpi">
                    <div className="kqm-kpi-label">Total partições</div>
                    <div className="kqm-kpi-value">{topics.length}</div>
                  </div>
                  <div className="kqm-kpi">
                    <div className="kqm-kpi-label">Total hosts</div>
                    <div className="kqm-kpi-value">{hosts.length}</div>
                  </div>
                  <div className="kqm-kpi">
                    <div className="kqm-kpi-label">Total processado</div>
                    <div className="kqm-kpi-value">{fmt.format(totalProcessado)}</div>
                  </div>
                </div>

                <div className="kqm-sechead">
                  <span className="kqm-sectitle">
                    <AppIcon name="snowing" size={20} />&nbsp;Mapa de partições
                  </span>
                  <InputGroup
                    className="kqm-ip-filter"
                    placeholder="Filtrar por IP / host"
                    value={this.obs.ip_filter}
                    onChange={(e) => this.obs.ip_filter = e.target.value}
                    rightElement={
                      this.obs.ip_filter ? (
                        <IconButton sx={{ padding: 0.5, marginTop: 1, marginRight: 1 }} onClick={() => this.obs.ip_filter = ""}>
                          <AppIcon name="close" size={16} />
                        </IconButton>
                      ) : undefined
                    }
                  />
                  <span className="kqm-legend">
                    {([
                      { tone: "ok", label: "Em dia" },
                      { tone: "warn", label: "Atrasando" },
                      { tone: "crit", label: "Crítico" },
                    ] as { tone: Tone; label: string }[]).map(({ tone, label }) => {
                      const active = this.obs.tone_filter === tone;
                      return (
                        <button
                          type="button"
                          key={tone}
                          className={`kqm-leg kqm-leg-btn${active ? " is-active" : ""}`}
                          onClick={() => this.obs.tone_filter = active ? null : tone}
                          aria-pressed={active}
                          title={active ? "Remover filtro" : `Filtrar partições: ${label}`}
                        >
                          <i className={`kqm-sw kqm-tone-${tone}`} />
                          {label}
                        </button>
                      );
                    })}
                  </span>
                </div>

                <div className="kqm-grid">
                  {ordered.length === 0 && (
                    <div className="kqm-grid-empty">
                      Nenhuma partição encontrada para o filtro informado.
                    </div>
                  )}
                  {ordered.map((topic) => {
                    const part = n(topic.partition);
                    const lag = n(topic.lag);
                    const tone = lagTone(lag);
                    const sel = part === this.obs.selected;
                    return (
                      <button
                        key={part}
                        type="button"
                        className={`kqm-cell kqm-cell-${tone}${sel ? " is-selected" : ""}`}
                        onClick={() => (this.obs.selected = part)}
                        aria-pressed={sel}
                        title={`Partição ${part} · lag ${fmt.format(lag)}`}
                      >
                        <span className="kqm-cell-top">
                          <span className="kqm-pn">P{part}</span>
                        </span>
                        <span className="kqm-cell-lag">
                          <span className="kqm-cell-lag-value">{fmt.format(lag)}</span>
                          <span className="kqm-cell-lag-label">lag</span>
                        </span>
                        <span className="kqm-cell-host" title={topic.host}>
                          <AppIcon name="dns" size={12} />
                          &nbsp;{maskHost(topic.host)}
                        </span>
                      </button>
                    );
                  })}
                </div>

                <div className="kqm-detail">
                  {selected ? (
                    (() => {
                      const sLag = n(selected.lag);
                      const sTone = lagTone(sLag);
                      const sCurrent = n(selected.current_offset);
                      const sLogEnd =
                        (selected as any).log_end_offset != null
                          ? n((selected as any).log_end_offset)
                          : sCurrent + sLag;
                      const consumedPct =
                        sLogEnd > 0
                          ? Math.min(100, Math.round((sCurrent / sLogEnd) * 100))
                          : 100;
                      return (
                        <>
                          <div className="kqm-detail-head">
                            <span className="kqm-detail-title">
                              <span className={`kqm-dot kqm-fg-${sTone}`} />
                              Partição {n(selected.partition)}
                            </span>
                            <span className={`kqm-pill kqm-tone-${sTone}`}>
                              Pendente: {fmt.format(sLag)}
                            </span>
                          </div>

                          <div className="kqm-detail-progress">
                            <div className="kqm-detail-progress-meta">
                              <span>Consumo</span>
                              <span>{consumedPct}%</span>
                            </div>
                            <div className="kqm-detail-progress-track">
                              <div
                                className={`kqm-detail-progress-fill kqm-fillbg-${sTone}`}
                                style={{ width: `${consumedPct}%` }}
                              />
                            </div>
                          </div>

                          <dl className="kqm-detail-grid">
                            <div className="kqm-detail-item">
                              <dt>Processado</dt>
                              <dd>{fmt.format(sCurrent)}</dd>
                            </div>
                            <div className="kqm-detail-item">
                              <dt>Processado + Pendente</dt>
                              <dd>{fmt.format(sLogEnd)}</dd>
                            </div>
                            <div className="kqm-detail-item">
                              <dt>Pendente</dt>
                              <dd className={`kqm-fg-${sTone}`}>{fmt.format(sLag)}</dd>
                            </div>
                            <div className="kqm-detail-item">
                              <dt>Host</dt>
                              <dd className="kqm-detail-host">{maskHost(selected.host)}</dd>
                            </div>
                          </dl>
                        </>
                      );
                    })()
                  ) : (
                    <div className="kqm-detail-empty">
                      Selecione uma partição acima para ver o detalhe.
                    </div>
                  )}
                </div>

                <button
                  type="button"
                  className="kqm-hosts-toggle"
                  onClick={() => this.obs.show_hosts = !this.obs.show_hosts}
                  aria-expanded={this.obs.show_hosts}
                >
                  <AppIcon name="dns" size={20} />
                  &nbsp;
                  <span className="kqm-sectitle">Distribuição por host</span>
                  <AppIcon
                    name={this.obs.show_hosts ? "expand_less" : "expand_more"}
                    size={20}
                  />
                </button>

                {this.obs.show_hosts && (
                <div className="kqm-hosts">
                  {hosts.map((h) => {
                    const pct = topics.length
                      ? Math.round((h.count / topics.length) * 100)
                      : 0;
                    return (
                      <div className="kqm-host" key={h.host}>
                        <div className="kqm-host-meta">
                          <span>{maskHost(h.host)}</span>
                          <span className="kqm-text-dim">{h.count} partições</span>
                        </div>
                        <div className="kqm-host-bar">
                          <div className="kqm-host-fill" style={{ width: `${pct}%` }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
                )}

              </>)}
            </>}
        </div>

        <div style={{ marginBottom: 120 }}/>

        <Dialog isOpen={this.obs.open_topics}>
          <h2 className="titleSEFAZ" style={{ marginBottom: 5 }}>Tópicos</h2>

          <FormGroup style={{ float: "right", width: "max-content" }}>
            <MDBBtn className="btnDefault" onClick={() => {
              MonitoraTopicStore.obs.topics = [
                {
                  _id: null,
                  topic: "",
                  inserted_at: null
                },
                ...MonitoraTopicStore.obs.topics
              ];
            }}>
              Novo Tópico
            </MDBBtn>
          </FormGroup>

          <FormGroup>
            <div className="select-empresa-sefa sefa-agendamento">
              <BootstrapTable hover data={MonitoraTopicStore.obs.topics} cellEdit={cellEditProp} options={options} search>
                <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden>#</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.formaterLocator} dataField="topic" editable={textEdit} width="40%">Tópico</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.formaterDate} editable={false} dataField="inserted_at" width="20%">Criado em</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.formaterDetalhes} editable={false} width="10%">Excluir</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Fechar"
              intent="primary"
              onClick={() => this.obs.open_topics = false}
            />
          </div>

        </Dialog>

        <Dialog isOpen={this.obs.open_monitorar} onClose={() => this.obs.open_monitorar = false}>
          <h2 className="titleSEFAZ" style={{ marginBottom: 5 }}>Monitorar</h2>

          <FormGroup label="Selecione e ordene os tópicos que deseja monitorar" labelInfo="*"
            helperText="Clique em um tópico para selecioná-lo. A ordem à direita define qual será monitorado primeiro.">
            <div className="monitora-transfer">

              <div className="monitora-pane">
                <div className="monitora-pane-head">
                  <span>Disponíveis</span>
                  <IconButton sx={{ padding: 0.5 }} disabled={availableTopics.length === 0} onClick={() => this.addAllTopics(availableTopics)}>
                    <AppIcon name="keyboard_double_arrow_right" size={18} />
                  </IconButton>
                </div>
                <InputGroup
                  className="monitora-pane-search"
                  leftIcon="search"
                  placeholder="Filtrar tópico"
                  value={this.obs.monitorar_filter}
                  onChange={(e) => this.obs.monitorar_filter = e.target.value}
                />
                <ul className="monitora-pane-list">
                  {availableTopics.length === 0 ? (
                    <li className="monitora-pane-empty">Nenhum tópico disponível.</li>
                  ) : availableTopics.map((topic) => (
                    <li className="monitora-pane-item is-clickable" key={topic} onClick={() => this.addTopic(topic)}>
                      <span className="monitora-pane-topic">{topic}</span>
                      <IconButton sx={{ padding: 0.5 }}>
                        <AppIcon name="keyboard_arrow_right" size={18} />
                      </IconButton>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="monitora-pane">
                <div className="monitora-pane-head">
                  <span>Selecionados ({this.obs.selected_topics.length})</span>
                  <IconButton sx={{ padding: 0.5 }} onClick={() => this.removeAllTopics()} disabled={this.obs.selected_topics.length === 0}>
                    <AppIcon name="close" size={18} color="#d95050" />
                  </IconButton>
                </div>
                <ol className="monitora-pane-list monitora-pane-list-select">
                  {this.obs.selected_topics.length === 0 ? (
                    <li className="monitora-pane-empty">Nenhum tópico selecionado.</li>
                  ) : this.obs.selected_topics.map((topic, index) => (
                    <li className="monitora-pane-item" key={topic}>
                      <span className="monitora-order-num">{index + 1}º</span>
                      <span className="monitora-pane-topic">{topic}</span>
                      <div className="monitora-order-actions">
                        <IconButton sx={{ padding: 0.5 }} disabled={index === 0} onClick={() => this.moveTopic(index, -1)}>
                          <AppIcon name="keyboard_arrow_up" size={18} />
                        </IconButton>
                        <IconButton sx={{ padding: 0.5 }} disabled={index === this.obs.selected_topics.length - 1} onClick={() => this.moveTopic(index, 1)}>
                          <AppIcon name="keyboard_arrow_down" size={18} />
                        </IconButton>
                        <IconButton sx={{ padding: 0.5 }} onClick={() => this.removeTopic(topic)}>
                          <AppIcon name="remove" size={18} color="#d95050" />
                        </IconButton>
                      </div>
                    </li>
                  ))}
                </ol>
              </div>

            </div>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.obs.open_monitorar = false} />
            <Button text="Monitorar" intent="primary" onClick={() => this.handleMonitorar()} />
          </div>

        </Dialog>

      </>
    );
  }
}

export default MonitoraTopicPage;